import './TitleRankIndicator.scss';

interface TitleRankIndicatorProps {
  titleRank: number;
  titleModifier?: string;
  titleArea?: string;
  titleRole?: string;
}

export default function TitleRankIndicator({
  titleRank,
  titleModifier,
  titleArea,
  titleRole
}: TitleRankIndicatorProps) {
  // Clamp titleRank between 0 and 100
  const clampedRank = Math.max(0, Math.min(100, titleRank || 0));

  // Build tooltip content with HTML line breaks
  const buildTooltipContent = () => {
    const parts = [
      '<div class="title-rank-indicator-title">Title breakdown</div>',
      `<div><span class="title-rank-indicator-rank title-rank-label">Rank</span> <span class="title-rank-indicator-value">${clampedRank}</span></div>`
    ];

    if (titleModifier) {
      parts.push(`<div><span class="title-rank-label">Modifier</span> <span class="title-rank-indicator-value">${titleModifier}</span></div>`);
    }
    if (titleRole) {
      parts.push(`<div><span class="title-rank-label">Role</span> <span class="title-rank-indicator-value">${titleRole}</span></div>`);
    }
    if (titleArea) {
      parts.push(`<div><span class="title-rank-label">Area</span> <span class="title-rank-indicator-value">${titleArea}</span></div>`);
    }

    return parts.join('');
  };

  return (
    <div className="title-rank-indicator">
      <div
        className="title-rank-fill"
        style={{ width: `${clampedRank}%` }}
        data-tooltip-id="main-tooltip"
        data-tooltip-html={buildTooltipContent()}
        data-tooltip-delay-hide={0}
      />
    </div>
  );
}
